import React from "react"
import { useTranslation } from "react-i18next"

import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { TextInput } from "shared/ui/input/text/TextInput"

export interface BuildingReferenceSearchInputProps {
  loading?: boolean
  disabled?: boolean
}

export const BuildingReferenceSearchInput = React.memo(
  ({ loading, disabled }: BuildingReferenceSearchInputProps) => {
    const { t } = useTranslation()

    return (
      <TextInput.Root
        name="searchTerm"
        label={t("General.Search")}
        loading={loading}
        disabled={disabled}
        className="building-reference-filter__search input--elevated"
      >
        <TextInput.Label />
        <TextInput.Focus>
          <TextInput.Input />
          <TextInput.Clear />
          <TextInput.Affix>
            <Icon name={IconName.SEARCH} />
          </TextInput.Affix>
        </TextInput.Focus>
      </TextInput.Root>
    )
  }
)

BuildingReferenceSearchInput.displayName = "BuildingReferenceSearchInput"
